<template>
  <v-app id="inspire">
    <v-navigation-drawer 
      v-model="drawer"
      width="280"
      color="#E8E9F3"
    >
      <!-- Aquí van las opciones del menú -->
      <v-list bg-color="transparent">
        <!-- Items simples -->
        <v-list-item
          v-for="(item, index) in simpleItemsFiltrados"
          :key="'simple-' + index"
          color="primary"
          @click="seleccionarTab(item.tab)"
        >
          <template v-slot:prepend>
            <v-icon>{{ item.icon }}</v-icon>
          </template>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>

        <!-- Grupo Mantenimientos -->
        <v-list-group v-if="AccesoAdmin" value="mantenimientos">
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-database"
              title="Mantenimientos"
            ></v-list-item>
          </template>

          <v-list-item
            v-for="(subitem, index) in mantenimientosItems"
            :key="'mant-' + index"
            :prepend-icon="subitem.icon"
            :title="subitem.title"
            color="primary"
            @click="seleccionarTab(subitem.tab)"
          ></v-list-item>
        </v-list-group>

        <!-- Grupo Seguridad -->
        <v-list-group v-if="AccesoAdmin" value="seguridad">
          <template v-slot:activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-shield-lock"
              title="Seguridad"
            ></v-list-item>
          </template>

          <v-list-item
            v-for="(subitem, index) in seguridadItems"
            :key="'seg-' + index"
            :prepend-icon="subitem.icon"
            :title="subitem.title"
            color="primary"
            @click="seleccionarTab(subitem.tab)"
          ></v-list-item>
        </v-list-group>


        <!-- ✅ AGREGAR AQUÍ - Después de Seguridad -->
        <v-list-item
          v-if="AccesoAdmin"
          color="primary"
          @click="seleccionarTab('plantillasForm')"
        >
          <template v-slot:prepend>
            <v-icon>mdi-file-word</v-icon>
          </template>
          <v-list-item-title>Plantillas</v-list-item-title>
        </v-list-item>
        
        
        <!-- 📥 Importar minimizado en segundo plano -->
        <v-list-item
          v-if="importMinimizado || importCompletado"
          color="primary"
          @click="restaurarImportar"
        >
          <template v-slot:prepend>
            <v-badge
              v-if="importSubiendo"
              :content="importProgreso + '%'"
              color="#ce501b"
              floating
            >
              <v-icon color="#ce501b">mdi-file-import</v-icon>
            </v-badge>
            <v-icon v-else-if="importCompletado" color="success">
              mdi-check-circle
            </v-icon>
            <v-icon v-else color="#ce501b">mdi-file-import</v-icon>
          </template>

          <v-list-item-title>
            {{ importCompletado ? '✓ Importación lista' : 'Importando…' }}
          </v-list-item-title>

          <v-list-item-subtitle v-if="importNombre" style="font-size:11px;opacity:.8;">
            {{ importNombre }}
          </v-list-item-subtitle>

          <v-list-item-subtitle v-if="importSubiendo" class="mt-1">
            <v-progress-linear
              :model-value="importProgreso"
              color="#ce501b"
              height="3"
              rounded
            ></v-progress-linear>
          </v-list-item-subtitle>

          <template v-slot:append>
            <v-icon
              size="small"
              style="cursor:pointer;"
              title="Descartar"
              @click.stop="descartarImportar"
            >mdi-close</v-icon>
          </template>
        </v-list-item>



      </v-list>
    </v-navigation-drawer>

    <v-app-bar color="#004d82" dark>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-app-bar-title>ImagingSoft © Gestión Documental</v-app-bar-title>
      
        <!-- 👇 el indicador, pegado al título -->
        <descargas-header />

      <!-- Spacer para empujar el resto a la derecha -->
      <v-spacer></v-spacer>

      <!-- Botones de acción -->
      <v-btn
        v-if="AccesoBusqueda"
        icon
        @click="busquedaPorLote"
      >
        <v-icon>mdi-binoculars</v-icon>
        <v-tooltip
          activator="parent"
          location="bottom"
        >Búsqueda por lote</v-tooltip>
      </v-btn>

      <v-btn
        v-if="AccesoAuditoria"
        icon
        @click="seleccionarTab('historialProcesosForm')"
      >
        <v-icon>mdi-book-open-variant</v-icon>
        <v-tooltip
          activator="parent"
          location="bottom"
        >Visor eventos</v-tooltip>
      </v-btn>

      <v-btn
        v-if="AccesoBusqueda"
        icon
        @click="seleccionarTab('busquedaAvanzada')"
      >
        <v-icon>mdi-magnify</v-icon>
        <v-tooltip
          activator="parent"
          location="bottom" 
        >Búsqueda</v-tooltip>
      </v-btn>

      <!-- Campo de búsqueda -->
      <v-text-field
        v-if="AccesoBusqueda"
        v-model="searchQuery"
        prepend-inner-icon="mdi-magnify"
        placeholder="Buscar..."
        variant="outlined"
        density="compact"
        hide-details
        clearable
        class="mx-4"
        style="max-width: 300px;"
        @keyup.enter="realizarBusqueda"
      ></v-text-field>

      <!-- Menú de Usuario -->
      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            variant="text"
            prepend-icon="mdi-account-circle"
          >
            {{ nombreUsuario }}
            <v-icon end>mdi-menu-down</v-icon>
          </v-btn>
        </template>

        <v-list>

          <!-- ✅ NUEVO -->
          <v-list-item
            v-if="AccesoAdmin"
            prepend-icon="mdi-cog"
            title="Configuración de OCR: Audio y video"
            @click="abrirModalConfiguracion"
          ></v-list-item>

           <!-- Descargar detector de teclas  -->
                
            <v-list-item
              v-if="false"
              color="primary"
              @click="descargarDetectorTeclas"
              >
              <template v-slot:prepend>
                <v-icon>mdi-download-circle</v-icon>
              </template>
              <v-list-item-title>
                Detector de Teclas
              </v-list-item-title>
            </v-list-item>
  

            <v-list-item
              prepend-icon="mdi-keyboard"
              title="Atajos de teclado"
              @click="dialogAtajos = true"
            ></v-list-item>

          <v-list-item
            prepend-icon="mdi-lock-reset"
            title="Cambiar contraseña"
            @click="abrirModalCambiarContrasena"
          ></v-list-item>
          
          <v-list-item
            prepend-icon="mdi-logout"
            title="Cerrar sesión"
            @click="cerrarSesion"
          ></v-list-item>
        </v-list>
      </v-menu>

    </v-app-bar>

    <!-- Modal para Cambiar Contraseña -->
    <v-dialog v-model="dialogCambiarPassword" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h6 text-white" style="background-color: #004D82;">
          Cambiar contraseña
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrarModalCambiarContrasena"
            size="small"
            variant="text"
            color="white"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-form ref="formCambiarPassword" v-model="validForm">
            <!-- Nick (Usuario) - Solo lectura -->
            <v-text-field
              v-model="nombreUsuario"
              label="Nick:"
              prepend-icon="mdi-account"
              readonly
              variant="outlined"
              density="comfortable"
              class="mb-4"
            ></v-text-field>

            <!-- Nueva Contraseña -->
            <v-text-field
              v-model="nuevaPassword"
              :append-inner-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword1 ? 'text' : 'password'"
              label="Nueva clave:"
              prepend-icon="mdi-lock"
              variant="outlined"
              density="comfortable"
              :rules="passwordRules"
              @click:append-inner="showPassword1 = !showPassword1"
              class="mb-4"
            ></v-text-field>

            <!-- Confirmar Contraseña -->
            <v-text-field
              v-model="confirmarPassword"
              :append-inner-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword2 ? 'text' : 'password'"
              label="Confirmar clave:"
              prepend-icon="mdi-lock-check"
              variant="outlined"
              density="comfortable"
              :rules="confirmarPasswordRules"
              @click:append-inner="showPassword2 = !showPassword2"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            color="#ce501b"
            variant="elevated"
            @click="cambiarContrasena"
            :loading="loadingCambiarPassword"
            :disabled="!validForm"
          >
            OK
          </v-btn>
          <v-btn
            color="#9B9B9B"
            variant="elevated"
            @click="cerrarModalCambiarContrasena"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

   <!-- Modal Configuración -->
<v-dialog v-model="dialogConfiguracion" max-width="500px" persistent>
  <v-card>
    <v-card-title class="d-flex justify-space-between align-center text-white"
      style="background-color: #004D82;">
      <span>Configuración</span>
      <v-btn icon size="small" variant="text" color="white" @click="dialogConfiguracion = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pt-6">
      <v-text-field
        v-model="configUrl"
        label="URL"
        prepend-icon="mdi-link"
        variant="outlined"
        density="comfortable"
        class="mb-4"
      ></v-text-field>

      <v-text-field
        v-model="configToken"
        label="Token"
        prepend-icon="mdi-key-variant"
        variant="outlined"
        density="comfortable"
        class="mb-4"
      ></v-text-field>

      <v-select
      v-model="configEstado"
      :items="[
        { title: 'Activado', value: '1' },
        { title: 'Desactivado', value: '0' }
      ]"
      item-title="title"
      item-value="value"
      label="Estado"
      prepend-icon="mdi-toggle-switch"
      variant="outlined"
      density="comfortable"
      ></v-select>
    </v-card-text>

    <v-card-actions class="px-6 pb-4">
      <v-spacer></v-spacer>
      <v-btn
        color="#ce501b"
        variant="elevated"
        :loading="loadingConfiguracion"
        @click="guardarConfiguracion"
      >
        Guardar
      </v-btn>
      <v-btn color="#9B9B9B" variant="elevated" @click="dialogConfiguracion = false">
        Cancelar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>



<!-- Modal Atajos de Teclado -->
<v-dialog v-model="dialogAtajos" max-width="680px" scrollable>
  <v-card style="border-radius: 16px; overflow: hidden;">

    <!-- Header -->
    <v-card-title class="pa-0">
      <div class="d-flex align-center justify-space-between pa-4"
        style="background-color: #004d82;">
        <div class="d-flex align-center ga-3">
          <div style="width:36px;height:36px;border-radius:8px;
            background:rgba(255,255,255,0.14);display:flex;
            align-items:center;justify-content:center;">
            <v-icon color="white" size="20">mdi-keyboard</v-icon>
          </div>
          <div>
            <p style="margin:0;font-size:15px;font-weight:500;color:#fff;">
              Atajos de teclado
            </p>
            <p style="margin:0;font-size:12px;color:rgba(255,255,255,0.6);">
              ImagingSoft — Guía de atajos
            </p>
          </div>
        </div>
        <v-btn icon size="small" variant="text" color="white"
          @click="dialogAtajos = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-card-title>

    <!-- Body -->
    <v-card-text style="max-height:530px;padding:1.1rem 1.4rem;
      display:flex;flex-direction:column;gap:1.1rem;">

      <!-- Sección dinámica -->
      <section v-for="sec in seccionesAtajos" :key="sec.titulo">
        <div class="d-flex align-center ga-2 mb-2">
          <div :style="`width:26px;height:26px;border-radius:6px;
            background:${sec.bgIcon};display:flex;
            align-items:center;justify-content:center;flex-shrink:0;`">
            <v-icon :color="sec.colorIcon" size="14">{{ sec.icono }}</v-icon>
          </div>
          <span :style="`font-size:11px;font-weight:500;color:${sec.colorIcon};
            text-transform:uppercase;letter-spacing:0.07em;`">
            {{ sec.titulo }}
          </span>
        </div>

        <div style="display:grid;grid-template-columns:1fr 1fr;gap:5px;">
          <div
            v-for="atajo in sec.atajos"
            :key="atajo.desc"
            :style="`
              grid-column: ${atajo.fullRow ? 'span 2' : 'span 1'};
              display:flex;align-items:center;gap:10px;
              border-radius:8px;padding:7px 10px;
              border: 0.5px solid ${atajo.borderColor || 'rgba(0,0,0,0.1)'};
              background: ${atajo.bgColor || 'rgba(0,0,0,0.03)'};
            `"
          >
            <!-- Teclas -->
            <div class="d-flex align-center ga-1 flex-shrink-0">
              <template v-for="(k, i) in atajo.keys" :key="i">
                <span v-if="k === '+' || k === '→' || k === '—'"
                  style="font-size:11px;color:rgba(0,0,0,0.35);font-weight:500;">
                  {{ k }}
                </span>
                <kbd v-else :style="`
                  display:inline-flex;align-items:center;justify-content:center;
                  min-width:26px;height:22px;padding:0 6px;
                  background:#fff;border:0.5px solid rgba(0,0,0,0.18);
                  border-radius:5px;font-size:11px;font-weight:500;
                  font-family:monospace;white-space:nowrap;
                  color: ${atajo.kbdColor || '#111'};
                `">{{ k }}</kbd>
              </template>
            </div>

            <!-- Descripción -->
            <span :style="`font-size:12px;line-height:1.3;
              color:${atajo.descColor || 'rgba(0,0,0,0.55)'};`">
              {{ atajo.desc }}
            </span>

            <!-- Badge opcional -->
            <span v-if="atajo.badge"
              :style="`margin-left:auto;display:inline-flex;align-items:center;
                font-size:10px;font-weight:500;padding:2px 7px;border-radius:10px;
                white-space:nowrap;background:${atajo.badgeBg};
                color:${atajo.badgeColor};`">
              {{ atajo.badge }}
            </span>
          </div>
        </div>
      </section>

    </v-card-text>

    <!-- Footer -->
    <v-card-actions style="padding:0.8rem 1.4rem;
      border-top:0.5px solid rgba(0,0,0,0.08);">
      <v-icon size="14" color="grey">mdi-information-outline</v-icon>
      <span style="font-size:12px;color:rgba(0,0,0,0.4);margin-left:5px;">
          Algunos atajos están disponibles solo dentro de su módulo correspondiente
      </span>
      <v-spacer></v-spacer>
      <v-btn color="#004d82" variant="elevated"
        @click="dialogAtajos = false">
        Entendido
      </v-btn>
    </v-card-actions>

  </v-card>
</v-dialog>



    <!-- Modal Búsqueda por Lote -->
<v-dialog v-model="dialogBusquedaLote" max-width="550px" persistent>
  <v-card>
    <v-card-title class="d-flex justify-space-between align-center text-white" style="background-color: #004D82;">
      <span>Búsqueda por lote</span>
      <v-btn icon size="small" variant="text" color="white" @click="dialogBusquedaLote = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pt-6">
      <v-row align="center" class="mb-4">
        <v-col cols="3" class="text-right font-weight-bold">Plantilla</v-col>
        <v-col cols="9">
          <v-select
            v-model="lotePlantilla"
            :items="lotePlantillas"
            item-title="plantilla"
            item-value="codigo"
            placeholder="Seleccione..."
            variant="outlined"
            density="compact"
            hide-details
            clearable
            @update:model-value="cargarColumnasLote"
          ></v-select>
        </v-col>
      </v-row>

      <v-row align="center" class="mb-4">
        <v-col cols="3" class="text-right font-weight-bold">Columna</v-col>
        <v-col cols="9">
          <v-select
            v-model="loteColumna"
            :items="loteColumnas"
            item-title="nombre"
            item-value="nombre"
            placeholder="Seleccione..."
            variant="outlined"
            density="compact"
            hide-details
            clearable
            :disabled="!lotePlantilla"
          ></v-select>
        </v-col>
      </v-row>

      <v-row align="center" class="mb-2">
        <v-col cols="3" class="text-right font-weight-bold">Archivo</v-col>
        <v-col cols="9">
          <div class="d-flex align-center ga-2">
            <v-text-field
              :model-value="loteArchivo ? loteArchivo.name : ''"
              placeholder="Archivo no seleccionado..."
              variant="outlined"
              density="compact"
              hide-details
              readonly
              class="flex-grow-1"
            ></v-text-field>
            <v-btn color="#ffe8e1" variant="elevated" @click="$refs.fileInputLote.click()">
              Explorar
            </v-btn>
            <input
              ref="fileInputLote"
              type="file"
              accept=".txt"
              style="display: none;"
              @change="seleccionarArchivoLote"
            />
          </div>
        </v-col>
      </v-row>
    </v-card-text>

   <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
        
          <v-btn
            color="#ce501b"
            variant="elevated"
            :disabled="!lotePlantilla || !loteColumna || !loteArchivo"
            :loading="loadingLote"
            @click="busquedaLote"
          >
            Buscar
          </v-btn>

          <v-btn color="#9B9B9B" variant="elevated" @click="dialogBusquedaLote = false">Cancelar</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


    <v-main>
      <!-- AQUÍ SE RENDERIZAN LOS COMPONENTES SEGÚN LA TAB ACTIVA -->
      <div class="contenedor-body__general">
        
        <!-- Home / Bienvenida -->
       
        
        <!-- Recientes -->
        <RecientesForm v-if="tabActiva === 'recientes'" />
        <treeViewExperimental v-if="tabActiva === 'treeView'" @cambiar-tab="seleccionarTab" />
        <UsuarioForm v-if="tabActiva == 'usuarioForm'" />
        <GrupoForm v-if="tabActiva == 'grupoForm'" />
        <OficinaForm v-if="tabActiva == 'oficinaForm'" />
        <VolumenesForm v-if="tabActiva == 'volumenesForm'" />
        <PlantillasForm v-if="tabActiva == 'plantillasForm'" />
        <SeguridadAccesosForm v-if="tabActiva == 'seguridadAccesosForm'" />
        <PermisoPlantillaForm v-if="tabActiva == 'permisoPlantillaForm'" />
        <HistorialProcesosForm v-if="tabActiva == 'historialProcesosForm'"/>
       <!-- <BusquedaAvanzada v-if="tabActiva == 'busquedaAvanzada'"/> -->
       <BusquedaAvanzada v-if="tabActiva == 'busquedaAvanzada'" :busqueda-carpeta="busquedaCarpetaData"/> 
       
      </div>
    </v-main>

      <ImportarBg />

    <v-footer class="d-flex align-center justify-center ga-2 flex-wrap flex-grow-1 py-3" color="surface-light">
      <div class="flex-1-0-100 text-center mt-2">
        Copyright © {{ new Date().getFullYear() }} <strong>ImagingSoft</strong>
      </div>
    </v-footer>

  </v-app>
</template>

<script setup>
/* eslint-disable no-undef */
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/plugins/axios'
import { clearAuthStorage } from '@/utils/authStorage'
import Swal from 'sweetalert2'
import DescargasHeader from '@/components/experimental/DescargasHeader.vue'
import ImportarBg from '@/components/ImportarBg.vue'
import { useImportarMinimizado } from '@/components/experimental/useImportarMinimizado'
import { useDescargas } from '@/components/experimental/Usedescargas.js'


// Importar componente - CORREGIDO
import RecientesForm from './recientesForm.vue'
import treeViewExperimental from './experimental/treeViewExperimental.vue'
import UsuarioForm from './usuarioForm.vue'
import GrupoForm from './grupoForm.vue'
import OficinaForm from './ofinaForm.vue'
import VolumenesForm from './volumenesForm.vue'
import PlantillasForm from './plantillasForm.vue'
import SeguridadAccesosForm from './seguridadAccesosForm.vue'
import PermisoPlantillaForm from './permisoPlantillaForm.vue'
import HistorialProcesosForm from './historialProcesosForm.vue'
import BusquedaAvanzada from './busquedaAvanzada.vue'




// 📥 Importar en segundo plano
const {
  minimizado:    importMinimizado,
  nombreCarpeta: importNombre,
  subiendo:      importSubiendo,
  progreso:      importProgreso,
  completado:    importCompletado,
  restaurar:     restaurarImportar,
  descartar:     descartarImportar,
} = useImportarMinimizado()


const { procesarDescargaArchivo } = useDescargas()

const menuFocoActivo = ref(false)
const indiceFocoMenu = ref(-1)

// Reemplaza los computed por refs
const AccesoBusqueda = ref(false)
const AccesoAuditoria = ref(false)
const AccesoWorkflow = ref(false)
const AccesoAdmin = ref(false)

const router = useRouter()
const drawer = ref(true)
const nombreUsuario = ref('Usuario')
const searchQuery = ref('')
const tabActiva = ref('recientes') // Tab inicial
const loadingLote = ref(false)

const dialogCambiarPassword = ref(false)
const nuevaPassword = ref('')
const confirmarPassword = ref('')
const showPassword1 = ref(false)
const showPassword2 = ref(false)
const validForm = ref(false)
const loadingCambiarPassword = ref(false)
const formCambiarPassword = ref(null)

const dialogAtajos = ref(false)

const seccionesAtajos = [
  {
    titulo: 'Navegación general',
    icono: 'mdi-apps',
    bgIcon: '#E6F1FB',
    colorIcon: '#185FA5',
    atajos: [
      { keys: ['Alt','+','Z'],       desc: 'Abrir  búsqueda avanzada' },
      { keys: ['Alt','+','V'],       desc: 'Abrir visor de eventos' },
      { keys: ['Alt','+','L'],       desc: 'Abrir búsqueda por lote' },
      { keys: ['Alt','+','D'],       desc: 'Abrir búsqueda por lote' },
      { keys: ['Alt','+','M'],       desc: 'Activar navegación del menú' },
      { keys: ['↑','↓'],             desc: 'Recorrer opciones del menú' },
    ]
  },
  {
    titulo: 'Módulos de administración',
    icono: 'mdi-view-grid',
    bgIcon: '#EAF3DE',
    colorIcon: '#3B6D11',
    atajos: [
      { keys: ['Alt','+','N'],  desc: 'Abrir formulario de nuevo registro' },
      { keys: ['Alt','+','G'],  desc: 'Guardar el formulario abierto' },
      { keys: ['Alt','+','B'],  desc: 'Enfocar el campo de búsqueda' },
      {
        keys: ['Esc'],
        desc: 'Cerrar formulario o modal compatible',
        fullRow: true
      },
    ]
  },
  {
    titulo: 'Indexación',
    icono: 'mdi-file-document',
    bgIcon: '#FAEEDA',
    colorIcon: '#854F0B',
    atajos: [
      { keys: ['Alt','+','J'], desc: 'Ir a documentos indexados' },
      { keys: ['Alt','+','K'], desc: 'Ir a documentos no indexados' },
      { keys: ['Alt','+','C'], desc: 'Enfocar lista de documentos' },

      {
        keys: ['Alt','+','X'],
        desc: 'Primer campo / activar selección para desindexar',
        fullRow: true
      },

      {
        keys: ['Alt','+','T'],
        desc: 'Seleccionar / desmarcar todos los no indexados',
        fullRow: true
      },

      {
        keys: ['Espacio'],
        desc: 'Marcar / desmarcar documento enfocado',
        fullRow: true,
        bgColor: '#EBF4FF',
        borderColor: '#B5D4F4',
        descColor: '#0C447C',
        kbdColor: '#0C447C'
      },
      {
        keys: ['Shift','+','↑','↓'],
        desc: 'Extender selección en no indexados',
        fullRow: true,
        bgColor: '#FAEEDA',
        borderColor: '#EF9F27',
        descColor: '#633806',
        kbdColor: '#633806'
      },
      {
        keys: ['Shift','+','Home'],
        desc: 'Seleccionar hasta el primer no indexado',
        fullRow: true,
        bgColor: '#FAEEDA',
        borderColor: '#EF9F27',
        descColor: '#633806',
        kbdColor: '#633806'
      },
      {
        keys: ['Shift','+','End'],
        desc: 'Seleccionar hasta el último no indexado',
        fullRow: true,
        bgColor: '#FAEEDA',
        borderColor: '#EF9F27',
        descColor: '#633806',
        kbdColor: '#633806'
      },
      {
        keys: ['Enter','→','Enter'],
        desc: 'Desde un campo: ir a la lista y luego guardar',
        fullRow: true,
        bgColor: '#EBF4FF',
        borderColor: '#B5D4F4',
        descColor: '#0C447C',
        kbdColor: '#0C447C'
      },
      {
        keys: ['Supr'],
        desc: 'Eliminar documento no indexado enfocado',
        fullRow: true,
        bgColor: '#FCEBEB',
        borderColor: '#F09595',
        descColor: '#A32D2D',
        kbdColor: '#A32D2D',
        badge: 'peligroso',
        badgeBg: '#F7C1C1',
        badgeColor: '#791F1F'
      },
    ]
  },
  {
    titulo: 'Directorio principal',
    icono: 'mdi-folder-open',
    bgIcon: '#EEEDFE',
    colorIcon: '#534AB7',
    atajos: [
      { keys: ['Alt','+','A'],  desc: 'Enfocar árbol de carpetas' },
      { keys: ['↑','↓'],        desc: 'Navegar entre nodos visibles' },
      { keys: ['clic derecho'], desc: 'Abrir opciones del elemento' },
    ]
  },
  {
  titulo: 'Indexación de archivo Individual',
  icono: 'mdi-file-eye',
  bgIcon: '#F1EFE8',
  colorIcon: '#5F5E5A',
  atajos: [
    { keys: ['Ctrl','+','Alt','+','G'], desc: 'Guardar indexación' },
    { keys: ['Espacio'], desc: 'Reproducir / pausar audio o video' },
    { keys: ['←','→'], desc: 'Cambiar de página' },
    { keys: ['Home','End'], desc: 'Primera / última página' },
    {
      keys: ['Esc'],
      desc: 'Cerrar indexación de archivo',
      fullRow: true
    },
  ]
}
]


// Reglas de validación
const passwordRules = [
  v => !!v || 'La contraseña es requerida',
  v => (v && v.length >= 6) || 'La contraseña debe tener al menos 6 caracteres',
]

const confirmarPasswordRules = [
  v => !!v || 'Debe confirmar la contraseña',
  v => v === nuevaPassword.value || 'Las contraseñas no coinciden',
]

// Cargar nombre de usuario desde localStorage
onMounted(() => {
  const usuario = localStorage.getItem('nombreUsuario')
  //console.log('Usuario leído del localStorage:', usuario)   //Usarlo solo para ver los errores en el testeo de Software
  if (usuario) {
    nombreUsuario.value = usuario
  } else {
  //console.warn('No se encontró nombreUsuario en localStorage')   //Usarlo solo para ver los errores en el testeo de Software
  }

  // ✅ Leer permisos aquí
  AccesoBusqueda.value = Number(localStorage.getItem('busqueda')) === 1;
  AccesoAuditoria.value = Number(localStorage.getItem('auditoria')) === 1;
  AccesoWorkflow.value = Number(localStorage.getItem('workflow')) === 1;
  AccesoAdmin.value = localStorage.getItem('idUsuario') === '00001';
  
  // ✅ Agregar listener de atajos globales
  document.addEventListener('keydown', handleKeyboardGlobalApp)
})


// ✅ PRIMERO la función auxiliar
const enfocarItemMenu = (index) => {
  setTimeout(() => {
    const items = document.querySelectorAll('.v-navigation-drawer .v-list-item')
    if (items[index]) {
      items[index].focus()
      items.forEach((item, i) => {
        item.style.backgroundColor = i === index ? 'rgba(0, 77, 130, 0.15)' : ''
      })
    }
  }, 50)
}

const handleKeyboardGlobalApp = (event) => {

  // ✅ Alt+A → enfocar árbol de carpetas
  if (event.altKey && event.code === 'KeyA') {
    event.preventDefault()
    setTimeout(() => {
      // Buscar el primer item clickeable del árbol de carpetas
      const primerItem = document.querySelector(
        '.v-navigation-drawer ~ .v-main .v-list .v-list-item, ' +
        '.v-main .v-list .v-list-group .v-list-item'
      )
      if (primerItem) {
        primerItem.focus()
        primerItem.scrollIntoView({ block: 'nearest' })
      }
    }, 50)
    return
  }

    // ✅ Alt+M → activar/desactivar foco del menú lateral
  if (event.altKey && event.code === 'KeyM') {
    event.preventDefault()
    drawer.value = true  // asegurar que el drawer esté abierto
    menuFocoActivo.value = !menuFocoActivo.value
    if (menuFocoActivo.value) {
      indiceFocoMenu.value = 0
      enfocarItemMenu(0)
    } else {
      indiceFocoMenu.value = -1
      document.activeElement?.blur()
    }
    return
  }

  // ✅ Flechas para navegar el menú cuando está activo
  if (menuFocoActivo.value) {
    const items = document.querySelectorAll('.v-navigation-drawer .v-list-item')
    const total = items.length

    if (event.key === 'ArrowDown') {
      event.preventDefault()
      indiceFocoMenu.value = Math.min(indiceFocoMenu.value + 1, total - 1)
      enfocarItemMenu(indiceFocoMenu.value)
      return
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault()
      indiceFocoMenu.value = Math.max(indiceFocoMenu.value - 1, 0)
      enfocarItemMenu(indiceFocoMenu.value)
      return
    }

    if (event.key === 'Enter') {
      event.preventDefault()
      const items = document.querySelectorAll('.v-navigation-drawer .v-list-item')
      if (items[indiceFocoMenu.value]) {
        items[indiceFocoMenu.value].click()
        menuFocoActivo.value = false
        indiceFocoMenu.value = -1
      }
      return
    }

    if (event.key === 'Escape') {
      event.preventDefault()
      menuFocoActivo.value = false
      indiceFocoMenu.value = -1
      document.activeElement?.blur()
      return
    }
  }

  // ✅ ESC → cerrar modal Búsqueda por Lote
  if (event.code === 'Escape') {
    if (dialogBusquedaLote.value) {
      event.preventDefault()
      dialogBusquedaLote.value = false
    }
    return
  }

  // ✅ Enter → ejecutar búsqueda si el modal está abierto y los campos están completos
  if (event.code === 'Enter') {
    if (dialogBusquedaLote.value) {
      event.preventDefault()
      if (lotePlantilla.value && loteColumna.value && loteArchivo.value) {
        busquedaLote()
      }
    }
    return
  }

  // Alt + Shift + Z → Búsqueda Avanzada
  if (event.altKey && event.code === 'KeyZ') {
    event.preventDefault()
    if (AccesoBusqueda.value) {
      seleccionarTab('busquedaAvanzada')
    }
  }

  // Alt + Shift + V → Visor Eventos (Historial)
  if (event.altKey && event.code === 'KeyV') {
    event.preventDefault()
    if (AccesoAuditoria.value) {
      seleccionarTab('historialProcesosForm')
    }
  }

  // Alt + Shift + L → Búsqueda por Lote
  if (event.altKey && event.code === 'KeyL') {
    event.preventDefault()
    if (AccesoBusqueda.value) {
      busquedaPorLote()
    }
  }

  // ✅ Alt + D → abrir/cerrar menú lateral (toggle)
  if (event.altKey && event.code === 'KeyD') {
    event.preventDefault()
    drawer.value = !drawer.value
    // Si se cierra el menú, desactivar el foco de navegación
    if (!drawer.value) {
      menuFocoActivo.value = false
      indiceFocoMenu.value = -1
      document.activeElement?.blur()
    }
    return
  }


}

onUnmounted(() => {
  document.removeEventListener('keydown', handleKeyboardGlobalApp)
})


// Items simples del menú (sin submenús)
const simpleItems = ref([
  {
    title: 'Recientes',
    icon: 'mdi-calendar-clock',
    tab: 'recientes'
  },
  {
    title: 'Explorador',
    icon: 'mdi-book-open-page-variant',
    tab: 'treeView'
  }

])

const simpleItemsFiltrados = computed(() => {
  return simpleItems.value.filter(item => {
    if (item.tab === 'recientes') return AccesoAuditoria.value
    if (item.tab === 'treeView') return AccesoWorkflow.value
    return true
  })
} );

// Subitems de Mantenimientos
const mantenimientosItems = ref([
  {
    title: 'Usuarios',
    icon: 'mdi-account-multiple',
    tab: 'usuarioForm'
  },
  {
    title: 'Grupos',
    icon: 'mdi-account-group',
    tab: 'grupoForm'
  },
  {
    title: 'Oficinas',
    icon: 'mdi-office-building',
    tab: 'oficinaForm'
  },
  {
    title: 'Volúmenes',
    icon: 'mdi-harddisk',
    tab: 'volumenesForm'
  }
])

// Subitems de Seguridad
const seguridadItems = ref([
  {
    title: 'Accesos',
    icon: 'mdi-key',
    tab: 'seguridadAccesosForm'
  },
  {
    title: 'Permiso de Plantillas',
    icon: 'mdi-file-lock',
    tab: 'permisoPlantillaForm'
  }
])


// Configuración
const dialogConfiguracion = ref(false)
const configUrl = ref('')
const configToken = ref('')
const configEstado = ref('1')
const loadingConfiguracion = ref(false)


const abrirModalConfiguracion = async () => {
  dialogConfiguracion.value = true
  try {
    const response = await axios.get('/api/Configuracion/get')
    if (response.data.success && response.data.data) {
      configUrl.value   = response.data.data.url    || ''
      configToken.value = response.data.data.touken || ''   // ✅ era .token → .touken
      configEstado.value = String(response.data.data.estado ?? '1') // ✅ convierte 0/1 a string para el v-select
    }
  } catch {
    // sin config aún, valores vacíos
  }
}



const guardarConfiguracion = async () => {
  loadingConfiguracion.value = true
  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario') // ✅ faltaba esto

    const response = await axios.post(
      `/api/Configuracion/save?idUsuarioSesion=${idUsuarioSesion}`, // ✅ faltaba el query param
      {
        url:    configUrl.value,
        touken: configToken.value,          // ✅ era "token" → "touken"
        estado: parseInt(configEstado.value) // ✅ era string → int
      }
    )
    if (response.data.success) {
      dialogConfiguracion.value = false
      Swal.fire({
        icon: 'success',
        iconColor: '#ce501b',
        title: 'Guardado',
        text: 'Configuración guardada correctamente',
        timer: 1500,
        showConfirmButton: false,
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      })
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: error.response?.data?.mensaje || 'No se pudo guardar la configuración',
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
    })
  } finally {
    loadingConfiguracion.value = false
  }
}

// Métodos para el modal de cambiar contraseña
const abrirModalCambiarContrasena = () => {
  dialogCambiarPassword.value = true
  nuevaPassword.value = ''
  confirmarPassword.value = ''
  showPassword1.value = false
  showPassword2.value = false
}

const cerrarModalCambiarContrasena = () => {
  dialogCambiarPassword.value = false
}

const cambiarContrasena = async () => {
  const { valid } = await formCambiarPassword.value.validate()
  
  if (!valid) {
    return
  }

  loadingCambiarPassword.value = true

  try {
    const idUsuario = localStorage.getItem('idUsuario')
    
    if (!idUsuario) {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: 'No se pudo obtener la información del usuario',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      })
      loadingCambiarPassword.value = false
      return
    }

    const response = await axios.post('/api/Users/change-password', {
      idUsuario: idUsuario,
      password: nuevaPassword.value
    })

    loadingCambiarPassword.value = false

    if (response.data.success) {
      cerrarModalCambiarContrasena()
      
      await Swal.fire({
        icon: 'success',
        iconColor: '#ce501b',
        title: '¡Éxito!',
        text: 'Tu contraseña ha sido cambiada exitosamente. Serás redirigido al login.',
        confirmButtonColor: '#ce501b',
        customClass: {
          title: 'swal-title-custom',
          confirmButton: 'swal-btn-confirmar',
          container: 'swal-sobre-modal'
        }
      })
      
      await cerrarSesion()
    } else {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: response.data.mensaje || 'No se pudo cambiar la contraseña',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      })
    }

  } catch (error) {
    loadingCambiarPassword.value = false
    //console.error('Error al cambiar contraseña:', error)     //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: error.response?.data?.mensaje || 'Hubo un problema al cambiar la contraseña',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    })
  }
}

const cerrarSesion = async () => {
  const idUsuario = localStorage.getItem('idUsuario')

  try {
    if (idUsuario) {
      await axios.post('/api/Users/logout', {
        idUsuario
      })

      await Swal.fire({
        icon: 'success',
        iconColor: '#ce501b',
        title: 'Sesión cerrada',
        text: 'Has cerrado sesión exitosamente',
        timer: 1500,
        confirmButtonColor: '#ce501b',
        customClass: {
          title: 'swal-title-custom',
          confirmButton: 'swal-btn-confirmar',
          container: 'swal-sobre-modal'
        },
        showConfirmButton: false
      })
    }
  } catch (error) {
    // Aunque el servidor no responda, la sesión local se cerrará.
    // console.error('Error al cerrar sesión:', error)
  } finally {
    clearAuthStorage()
    router.replace('/')
  }
}


const dialogBusquedaLote = ref(false);
const lotePlantilla = ref(null);
const loteColumna = ref(null);
const loteArchivo = ref(null);
const lotePlantillas = ref([]);
const loteColumnas = ref([]);


// Métodos para los botones de acción
const busquedaPorLote = async () => {
  dialogBusquedaLote.value = true;
  lotePlantilla.value = null;
  loteColumna.value = null;
  loteArchivo.value = null;
  loteColumnas.value = [];

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');
    const response = await axios.get(
      `/api/Plantillas/list-plantillas?idUsuarioSesion=${idUsuarioSesion}`
    );
    if (response.data.success) {
      lotePlantillas.value = response.data.data;
    }
  } catch (error) {
    //console.error('Error al cargar plantillas:', error);     //Usarlo solo para ver los errores en el testeo de Software
  }
};

const cargarColumnasLote = async () => {
  if (!lotePlantilla.value) {
    loteColumnas.value = [];
    loteColumna.value = null;
    return;
  }
  try {
    const response = await axios.get(
      `/api/Plantillas/estructura/${lotePlantilla.value}`
    );
    if (response.data.success) {
      loteColumnas.value = response.data.data.map(campo => ({
        nombre: campo.column_name,
        tipo: campo.data_type
      }));
    }
  } catch (error) {
    //console.error('Error al cargar columnas:', error);     //Usarlo solo para ver los errores en el testeo de Software
    loteColumnas.value = [];
  }
};


const seleccionarArchivoLote = (event) => {
  const file = event.target.files[0];
  
  if (file) {
    const extension = file.name.split('.').pop().toLowerCase();
    
    if (extension !== 'txt') {
      Swal.fire({
        icon: 'warning',
        iconColor: '#ce501b',
        title: 'Archivo no permitido',
        text: 'Solo se permiten archivos con extensión .txt',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#ce501b',
        customClass: {
          title: 'swal-title-custom',
          confirmButton: 'swal-btn-confirmar',
          container: 'swal-over-modal'
        }
      });
      event.target.value = '';
      loteArchivo.value = null;
      return;
    }
    
    loteArchivo.value = file;
  }
  
  event.target.value = '';
};




const todosLosItems = computed(() => [
  ...simpleItems.value,
  ...mantenimientosItems.value,
  ...seguridadItems.value,
  { title: 'Plantillas', icon: 'mdi-file-word', tab: 'plantillasForm' },
  { title: 'Búsqueda Avanzada', icon: 'mdi-magnify', tab: 'busquedaAvanzada' },
  { title: 'Historial de Procesos', icon: 'mdi-book-open-variant', tab: 'historialProcesosForm' },
  // Alias para grupos padre → llevan al primer subitem
  { title: 'Mantenimientos', icon: 'mdi-database', tab: 'usuarioForm' },
  { title: 'Seguridad', icon: 'mdi-shield-lock', tab: 'seguridadAccesosForm' },
]);


const realizarBusqueda = () => {
  if (!searchQuery.value || !searchQuery.value.trim()) return;

  const busqueda = searchQuery.value.trim().toLowerCase();

  // Buscar coincidencia en los items del menú
  const encontrado = todosLosItems.value.find(item =>
    item.title.toLowerCase().includes(busqueda)
  );

  if (encontrado) {
    seleccionarTab(encontrado.tab);
    searchQuery.value = '';
  } else {
    Swal.fire({
      icon: 'info',
      iconColor: '#ce501b',
      title: 'No encontrado',
      text: `No se encontró ningún módulo con: "${searchQuery.value}"`,
      timer: 2000,
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
      showConfirmButton: false
    });
  }
};


// Variables para pasar datos a BusquedaAvanzada
const busquedaCarpetaData = ref(null);

// Método para cambiar de tab

const seleccionarTab = (tab) => {
  if (typeof tab === 'object' && tab.tab) {
    tabActiva.value = tab.tab
    busquedaCarpetaData.value = {
      plantillaId: tab.plantillaId,
      tocId: tab.tocId,
      nombreCarpeta: tab.nombreCarpeta,
      estructuraCargada: tab.estructuraCargada || null,
      busquedaLote: tab.busquedaLote || null         // ← DATOS DE LOTE
    }
  } else {
    tabActiva.value = tab
    busquedaCarpetaData.value = null
  }
  //console.log('Tab seleccionada:', tab)   //Usarlo solo para ver los errores en el testeo de Software
}


const busquedaLote = async () => {
  if (!lotePlantilla.value || !loteColumna.value || !loteArchivo.value) return

  loadingLote.value = true

  try {
    // 1. Leer el contenido del archivo .txt
    const textoArchivo = await loteArchivo.value.text()

    if (!textoArchivo || !textoArchivo.trim()) {
      Swal.fire({ 
        icon: 'warning',
        iconColor: '#ce501b',
        title: 'Archivo vacío',
        text: 'El archivo no contiene texto para buscar',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
       })
      loadingLote.value = false
      return
    }

    //console.log('[LOTE] Plantilla:', lotePlantilla.value)    //Usarlo solo para ver los errores en el testeo de Software
    //console.log('[LOTE] Columna:', loteColumna.value)        //Usarlo solo para ver los errores en el testeo de Software
    //console.log('[LOTE] Texto archivo:', textoArchivo.substring(0, 200))   //Usarlo solo para ver los errores en el testeo de Software

    // 2. Cerrar el modal
    dialogBusquedaLote.value = false

    // 3. Navegar a Búsqueda Avanzada pasando los datos del lote
    seleccionarTab({
      tab: 'busquedaAvanzada',
      plantillaId: parseInt(lotePlantilla.value),
      tocId: 0,
      nombreCarpeta: 'Búsqueda por Lote',
      estructuraCargada: null,
      busquedaLote: {
        columna: loteColumna.value,
        texto: textoArchivo.trim(),
        plantillaId: lotePlantilla.value
      }
    })

  } catch (error) {
    //console.error('Error en búsqueda por lote:', error)   //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({ 
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'No se pudo leer el archivo',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    })
  } finally {
    loadingLote.value = false
  }
};


const descargarDetectorTeclas = async () => {
  const idUsuarioSesion = localStorage.getItem('idUsuario')

  await procesarDescargaArchivo({
    url: `/api/Doc/descargar-detector-teclas?idUsuarioSesion=${idUsuarioSesion}`,
    nombre: 'SAFD-DetectorTeclas.exe'
  })
}


</script>

<style>
/* Sin scoped para que afecte al portal de SweetAlert */
.swal-over-modal {
  z-index: 9999 !important;
}
</style>


<style scoped>
.contenedor-body__general {
  padding: 20px;
  min-height: calc(100vh - 64px - 52px);
}

/* Estilos para el menú desplegable */
:deep(.v-list-group__items) {
  background-color: rgba(0, 0, 0, 0.03);
}

:deep(.v-list-item--active) {
  color: #004d82 !important;
}

/* Ajustar el padding de los items para mejor visualización */
:deep(.v-list-item) {
  padding-inline: 12px !important;
  cursor: pointer;
}

:deep(.v-list-item__prepend) {
  margin-inline-end: 12px !important;
}
</style>

<style>

.swal-title-custom {
  color: #004d82 !important;
}

.swal-btn-confirmar {
  color: white !important;
}

</style>

<style>

.swal-title-custom {
  color: #004d82 !important;
  font-size: 1.3rem !important;
}

.swal-text-custom {
  color: #555555 !important;
  font-size: 0.95rem !important;
}

.swal-btn-custom {
  background-color: #ce501b !important;
  color: #ffffff !important;
  border-radius: 6px !important;
  padding: 8px 24px !important;
}

.swal-btn-custom:hover {
  background-color: #a83d14 !important;
}

.swal-btn-confirmar {
  color: white !important;
}

</style>

<style>
.swal-sobre-modal {
  z-index: 10000 !important;
}
</style>